import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { Dropdown, Typography } from "antd";
import type { MenuProps } from "antd";
import styled from "styled-components/macro";

const { Text } = Typography;

export interface RecentFieldsButtonProps {
  text: string;
  recentItems: MenuProps["items"];
  onRecentItemClick: MenuProps["onClick"];
  onClick?: () => void;
  isSelected?: boolean;
  className?: string;
  buttonRef?: React.Ref<HTMLDivElement>;
  dataTestId?: string;
}

export default function RecentFieldsButton({
  text,
  recentItems,
  onRecentItemClick,
  onClick,
  isSelected,
  className,
  buttonRef,
  dataTestId
}: RecentFieldsButtonProps) {
  return (
    <Wrapper className={className}>
      <Dropdown.Button
        className={isSelected ? "isSelected" : ""}
        onClick={onClick}
        placement="bottomRight"
        trigger={["click"]}
        icon={<AccessTimeOutlinedIcon />}
        menu={{
          items: recentItems,
          onClick: onRecentItemClick
        }}>
        <StyledText ellipsis ref={buttonRef} data-testid={dataTestId}>
          {text}
        </StyledText>
        <KeyboardArrowRightIcon fontSize="large" />
      </Dropdown.Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-width: 0;

  .isSelected .ant-btn-compact-first-item {
    color: var(--color-white);
    background-color: var(--color-text);
    font-weight: var(--fontWeightMedium);
  }

  .ant-btn-compact-first-item {
    min-width: 0;
  }

  .ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const StyledText = styled(Text)`
  color: inherit;
`;
